export default "__VITE_ASSET__DpNaV02r__"